export const base_url = "/";
